import { faFingerprint } from '@fortawesome/pro-regular-svg-icons/faFingerprint'
import { Box, Flex, Grid, TextInput, Text, Switch } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreCountryCode, type CoreCustomerDocType } from '@flecto/types'
import { BadgeCustomerVerification, CollapsibleCard } from '@flecto/ui'
import { SelectCountry } from '@flecto/ui/@shared/SelectCountry'
import { SelectDocType } from '@flecto/ui/@shared/SelectDocType'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'
import { useEffect } from 'react'

import { useFormContext } from './FormCustomer'

export function Identification() {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const { isMobile } = useMediaQuery()
  const form = useFormContext()

  const idDocumentType = form.getInputProps('id_document_type').value

  const idDocumentNumber = form.getInputProps('id_document_number').value
  const verified = form.getInputProps('id_verified_at').value

  useEffect(() => {
    if (!idDocumentNumber) {
      form.setFieldValue('id_document_number', '')

      form.setFieldValue('id_verified_at', null)
    }
  }, [idDocumentNumber])
  
  useEffect(() => {
    if (!idDocumentType) {
      form.setFieldValue('id_document_number', '')
      form.setFieldValue('id_document_type', '' as CoreCustomerDocType)

      form.setFieldValue('id_verified_at', null)
    }
  }, [idDocumentType])
  return (
    <Box mb='lg'>
      <CollapsibleCard>
        <CollapsibleCard.Title>
          {t('add_customer.identification')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('add_customer.customer_identification.subtitle')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Icon withCircleBackground icon={faFingerprint} />
        <CollapsibleCard.RightSection>
          <BadgeCustomerVerification
            customer={{
              id_verified_at: form.getInputProps('id_verified_at').value,
              id_document_type: idDocumentType,
              id_document_number:
                form.getInputProps('id_document_number')?.value,
            }}
          />
        </CollapsibleCard.RightSection>
        <CollapsibleCard.Content>
          <Grid mt='sm'>
            <Grid.Col span={isMobile ? 12 : 4}>
              <SelectCountry
                style={{ flex: 1 }}
                aria-label='address-country'
                label={t('nationality.label')}
                placeholder={t('nationality.placeholder')}
                {...form.getInputProps('nationality')}
              />
            </Grid.Col>
            <Grid.Col span={isMobile ? 12 : 4}>
              <SelectDocType
                key={idDocumentType || 'empty'}
                label={t('add_customer.id_type')}
                placeholder={t('document_type.civil')}
                value={form.getInputProps('id_document_type').value}
                defaultValue={form.getInputProps('id_document_type').value}
                {...form.getInputProps('id_document_type')}
                onChange={(value) => {
                  form.setFieldValue(
                    'id_document_type',
                    value as CoreCustomerDocType
                  )
                }}
              />
            </Grid.Col>
            <Grid.Col span={isMobile ? 12 : 4}>
              <TextInput
                mb='md'
                aria-label='address-title'
                label={t('id_number.label')}
                placeholder={t('id_number.placeholder')}
                disabled={!form.getInputProps('id_document_type').value}
                {...form.getInputProps('id_document_number')}
              />
            </Grid.Col>
          </Grid>
          <Flex mt='md' mb='xs' align='center'>
            <Box style={{ flex: 1 }}>
              <Flex direction='column'>
                <Text fw={'500'}>{t('add_customer.id_verify')}</Text>
                <Text c={'gray'} size={'sm'} fs='sm'>
                  {t('add_customer.id_verify_description')}
                </Text>
              </Flex>
            </Box>
            <Switch
              disabled={!idDocumentType || !idDocumentNumber}
              checked={!!verified && !!idDocumentType && !!idDocumentNumber}
              onChange={() =>
                form.setFieldValue('id_verified_at', verified ? '' : 'on')
              }
            />
          </Flex>
        </CollapsibleCard.Content>
      </CollapsibleCard>
    </Box>
  )
}
